module.exports = __webpack_public_path__ + "img/google-play-badge.9e94e068.png";